import { render, staticRenderFns } from "./s_Certificates.vue?vue&type=template&id=2a58477a&scoped=true&"
import script from "./s_Certificates.vue?vue&type=script&lang=js&"
export * from "./s_Certificates.vue?vue&type=script&lang=js&"
import style0 from "./s_Certificates.vue?vue&type=style&index=0&id=2a58477a&prod&lang=css&"
import style1 from "./s_Certificates.vue?vue&type=style&index=1&id=2a58477a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a58477a",
  null
  
)

export default component.exports